export type IncomeCategoryKey = "Income" | "Benefits" | "Pensions" | "Other";

export const categoryMaxValues: Record<IncomeCategoryKey, number> = {
  Income: 100000,
  Benefits: 10000,
  Pensions: 10000,
  Other: 10000,
};

export type FixedParentKey =
  | "Home & Contents"
  | "Pensions & Insurance"
  | "Water"
  | "Professional Costs"
  | "Care & Health"
  | "Utilities"
  | "School Costs"
  | "Transport & Travel";

export const fixedValue: Record<FixedParentKey, number> = {
  "Home & Contents": 10000,
  "Pensions & Insurance": 10000,
  Water: 10000,
  "Professional Costs": 10000,
  "Care & Health": 10000,
  Utilities: 10000,
  "School Costs": 10000,
  "Transport & Travel": 10000,
};

export type FlexibleParentKey =
  | "Communications & Leisure"
  | "Food & Housekeeping"
  | "Personal Costs"
  | "Savings";

export const flexValue: Record<FlexibleParentKey, number> = {
  "Communications & Leisure": 10000,
  "Food & Housekeeping": 10000,
  "Personal Costs": 10000,
  Savings: 10000,
};

export type AdditionalDebtParentKey = "Priority Debts" | "Non Priority Debts";

export const addDebtValue: Record<AdditionalDebtParentKey, number> = {
  "Priority Debts": 10000,
  "Non Priority Debts": 10000,
};
